/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import axios from '@/plugins/axios'
import { downLoad } from '@/utils'
import {
  postpoorList,
  postaddPoor,
  postreportPoor,
  postgetPoor,
  postlistHelp,
  postdeletePoor
} from './model'
import {ValidateType} from './model/utils'
const isPod = process.env.NODE_ENV === 'production'

let validatepoorList = new ValidateType(postpoorList.Req, 'api-general/api-general/module/portal/poorList', 'POST')
export function poorList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatepoorList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/poorList',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateaddPoor = new ValidateType(postaddPoor.Req, 'api-general/api-general/module/portal/addPoor', 'POST')
export function addPoor (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateaddPoor.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/addPoor',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatereportPoor = new ValidateType(postreportPoor.Req, 'api-general/api-general/module/portal/reportPoor', 'POST')
export function reportPoor (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatereportPoor.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/reportPoor',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetPoor = new ValidateType(postgetPoor.Req, 'api-general/api-general/module/portal/getPoor', 'POST')
export function getPoor (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetPoor.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/getPoor',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistHelp = new ValidateType(postlistHelp.Req, 'api-general/api-general/module/portal/listHelp', 'POST')
export function listHelp (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistHelp.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/listHelp',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatedeletePoor = new ValidateType(postdeletePoor.Req, 'api-general/api-general/module/portal/deletePoor', 'POST')
export function deletePoor (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatedeletePoor.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/portal/deletePoor',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}